module.exports = __webpack_public_path__ + "434f3bad784d44c75aa45ed9ec3e2871.svg";